/* eslint-disable */
/* tslint:disable */
/* auto-generated react proxies */
import { createReactComponent } from './react-component-lib';
export var PrivChartPopover = /*@__PURE__*/ createReactComponent('priv-chart-popover');
export var PrivDatepicker = /*@__PURE__*/ createReactComponent('priv-datepicker');
export var PrivNavigatorButton = /*@__PURE__*/ createReactComponent('priv-navigator-button');
export var PrivNavigatorItem = /*@__PURE__*/ createReactComponent('priv-navigator-item');
export var WmActionMenu = /*@__PURE__*/ createReactComponent('wm-action-menu');
export var WmButton = /*@__PURE__*/ createReactComponent('wm-button');
export var WmChart = /*@__PURE__*/ createReactComponent('wm-chart');
export var WmChartSlice = /*@__PURE__*/ createReactComponent('wm-chart-slice');
export var WmDatepicker = /*@__PURE__*/ createReactComponent('wm-datepicker');
export var WmFile = /*@__PURE__*/ createReactComponent('wm-file');
export var WmFileList = /*@__PURE__*/ createReactComponent('wm-file-list');
export var WmInput = /*@__PURE__*/ createReactComponent('wm-input');
export var WmLineChart = /*@__PURE__*/ createReactComponent('wm-line-chart');
export var WmMenuitem = /*@__PURE__*/ createReactComponent('wm-menuitem');
export var WmModal = /*@__PURE__*/ createReactComponent('wm-modal');
export var WmModalFooter = /*@__PURE__*/ createReactComponent('wm-modal-footer');
export var WmModalHeader = /*@__PURE__*/ createReactComponent('wm-modal-header');
export var WmNavigation = /*@__PURE__*/ createReactComponent('wm-navigation');
export var WmNavigationHamburger = /*@__PURE__*/ createReactComponent('wm-navigation-hamburger');
export var WmNavigationItem = /*@__PURE__*/ createReactComponent('wm-navigation-item');
export var WmNavigator = /*@__PURE__*/ createReactComponent('wm-navigator');
export var WmNetworkUploader = /*@__PURE__*/ createReactComponent('wm-network-uploader');
export var WmOption = /*@__PURE__*/ createReactComponent('wm-option');
export var WmPagination = /*@__PURE__*/ createReactComponent('wm-pagination');
export var WmProgressIndicator = /*@__PURE__*/ createReactComponent('wm-progress-indicator');
export var WmProgressMonitor = /*@__PURE__*/ createReactComponent('wm-progress-monitor');
export var WmProgressSlice = /*@__PURE__*/ createReactComponent('wm-progress-slice');
export var WmSearch = /*@__PURE__*/ createReactComponent('wm-search');
export var WmSelect = /*@__PURE__*/ createReactComponent('wm-select');
export var WmSnackbar = /*@__PURE__*/ createReactComponent('wm-snackbar');
export var WmTabItem = /*@__PURE__*/ createReactComponent('wm-tab-item');
export var WmTabList = /*@__PURE__*/ createReactComponent('wm-tab-list');
export var WmTabPanel = /*@__PURE__*/ createReactComponent('wm-tab-panel');
export var WmTagInput = /*@__PURE__*/ createReactComponent('wm-tag-input');
export var WmTagInputRow = /*@__PURE__*/ createReactComponent('wm-tag-input-row');
export var WmTimepicker = /*@__PURE__*/ createReactComponent('wm-timepicker');
export var WmToggletip = /*@__PURE__*/ createReactComponent('wm-toggletip');
export var WmUploader = /*@__PURE__*/ createReactComponent('wm-uploader');
export var WmWrapper = /*@__PURE__*/ createReactComponent('wm-wrapper');
//# sourceMappingURL=components.js.map